export default {
      id: "vaccines-usage",
      viewBox: "0 0 28 29",
      url: __webpack_public_path__ + "img/icons.svg#vaccines",
      toString: function () {
        return this.url;
      }
    }